import React from 'react';

interface FAQNavProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  categories: string[];
}

const FAQNav: React.FC<FAQNavProps> = ({ activeCategory, onCategoryChange, categories }) => {
  return (
    <div className="flex flex-col auto-cols-max md:grid-flow-row md:auto-rows-max mt-lg overflow-x-auto overflow-y-hidden no-scrollbar pl-0 md:pl-5">
      {categories.map((category) => (
        <div
          key={category}
          className="text-base md:text-base cursor-pointer relative flex items-center flex-shrink-0 max-w-auto mb-2 md:mb-8 mr-20 md:mr-0 pl-6 md:pl-5"
          onClick={() => onCategoryChange(category)}
        >
          {/* Using absolute positioning to match the original CSS ::before behavior */}
          <div
            className={`absolute w-2 h-2 rounded-full top-1.5 md:top-2 left-0 md:-left-4
              ${
                activeCategory === category
                  ? 'bg-blue-500' /* replace with your primary color */
                  : 'bg-transparent border border-black'
              }`}
          />
          <span className={activeCategory === category ? 'font-medium text-lg' : 'text-lg'}>
            {category}
          </span>
        </div>
      ))}
    </div>
  );
};

export default FAQNav;
